import React from 'react'

export default ({ name, color, size, extra }) => {
	let iconColor
	if (color === 'light' || color === 'dark') {
		iconColor = 'mdi-' + color + ' '
	}
	else if (color === undefined) {
		iconColor = ' '
	}
	else {
		iconColor = 'capps-social-icon capps-' + color + ' '
	}
	let iconSize = size ? 'mdi-' + size + 'px ' : 'mdi-24px '
	const iconName = 'mdi-' + name
	const iconClass = extra ? ' ' + extra : ''
	const className = 'mdi ' + iconColor + iconSize + iconName + iconClass
	return <span className={className} />
}



// WEBPACK FOOTER //
// ./src/Components/Display/Icon.js